import React from 'react'
import {
  CButton,
} from '@coreui/react-pro'
import { styleButtonVars3 } from '../custom-styles/buttonStyles'


const AppCardHeader = ({
  headerTitle,
  headerButton,
  headerDownloadButton,
  handleCardHeaderButton,
  downloadLink,
  downloadName,
  disabled,
  hidden
}) => {
  return (
    <div className="d-flex justify-content-between align-items-center">
      {headerTitle}
      {headerButton && (
        <CButton
          style={styleButtonVars3}
          onClick={() => handleCardHeaderButton()}
          disabled={disabled}
          hidden={hidden}
        >
          {headerButton}
        </CButton>
      )}
      {headerDownloadButton && downloadLink && downloadLink !== '' && (
        <CButton
          style={styleButtonVars3}
          href={downloadLink}
          download={downloadName}
          target="_blank"
          rel="noopener noreferrer"
        >
          {headerDownloadButton}
        </CButton>
      )}
    </div>
  )
}

export default AppCardHeader
